import { render, staticRenderFns } from "./BpRevenuePurchasesExpensesBarChart.vue?vue&type=template&id=55a3e3fa"
import script from "./BpRevenuePurchasesExpensesBarChart.vue?vue&type=script&lang=ts"
export * from "./BpRevenuePurchasesExpensesBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports